<div class="config-container shadow">
  <h4 (click)="toggleCollapse(SubStepEnum.Installations)" [ngClass]="{ active: subStep === SubStepEnum.Installations }"
    class="title configurator-subtitle collapse-button">
    <span>{{ 'fence.materials.installations' | translate }}</span>
  </h4>

  @if (subStep === SubStepEnum.Installations) {
    <ng-casto-materials-installation-simples></ng-casto-materials-installation-simples>

    <ng-casto-materials-installation-mixings></ng-casto-materials-installation-mixings>
  }
</div>
